unit uLockerContracts;

interface

uses
  System.SysUtils, System.Classes, JS, Web, Weblib.JSON, uLockerState;

type
  TAbstractUIBinding      = class;
  TAbstractStorageBinding = class;

  TStringArray = array of string;

  // ════════════════════════════════════════════════════════════════════════════
  // There are two TStringlist buffers here, one for the Storage data and one for the UI widgets.
  // The data in them looks like this: <external-name> : <internal-name> = <value>
  // These stringlists have DelimiterChar set by default to '=' so the data looks
  // like this: <name> = <value>
  // For UI use, we can split <name> into two parts: <external-name> : <internal-name>
  // using ':' as the DelimiterChar. But the two methods ExternalName and InternalName
  // simply use a Split function.

  TLockerBuffer = class
  private
    FLockerState    : TLockerState;
    FStorageBinding : TAbstractStorageBinding;
    FUIBinding      : TAbstractUIBinding;
    FFromStorage    : TStringlist;
    FFromWidgets    : TStringlist;

  public
    constructor Create(aLockerState    : TLockerState;
                       aStorageBinding : TAbstractStorageBinding;
                       aUIBinding      : TAbstractUIBinding = NIL);

    // compare and report changed keys
    function ChangedKeys: TStringList;
    // call this AFTER calling ChangedKeys
    function IsDirty: Boolean;

    procedure ToWidgets;
    procedure FromWidgets;
    [async] function ToStorage : string; async;
    [async] function FromStorage : string; async;
  end;

  // abstract base — form unit descends from this
  TAbstractUIBinding = class abstract
    procedure LoadWidgetsFromBuffer(aBuffer: TStringlist); virtual; abstract;
    procedure SendWidgetsToBuffer(aBuffer: TStringlist); virtual; abstract;
  end;

  // abstract base — storage unit descends from this
  TAbstractStorageBinding = class abstract
    [async] function  LoadBufferFromStorage(const aLockerID: string; aBuffer: TStringlist): string; async; virtual; abstract;
    [async] function  SendBufferToStorage(const aLockerID: string; aBuffer: TStringlist): string; async; virtual; abstract;
    function MetadataJSON : TJSONObject; virtual; abstract;
    function PromptJSON   : TJSONObject; virtual; abstract;
  end;

  // aCompoundKey should look like: <external-name> : <internal-name>
  function ExternalName(const aCompoundKey: string): string;
  //function InternalName(const aCompoundKey: string): string;
  // aLabel is an External name (eg., from a grid or label caption)
  function InternalName(const aLabel: string): string;

var
  LockerFieldNames : TStringList;

implementation

{ TLockerBuffer }

//===============================================================
function ExternalName(const aCompoundKey: string): string;
//===============================================================
var parts : TStringArray;
begin
  parts := aCompoundKey.Split([':']);
  Result := parts[0];
end;

//===============================================================
//function InternalName(const aCompoundKey: string): string;
//===============================================================
//var parts : TStringArray;
//begin
//  parts := aCompoundKey.Split([':']);
//  Result := parts[1];
//end;

//===============================================================
function InternalName(const aLabel: string): string;
//===============================================================
begin
  Result := LockerFieldNames.Values[aLabel];
  if (Result = '') then
    Result := LowerCase(StringReplace(aLabel, ' ', '_', [rfReplaceAll]));
end;

//===============================================================
constructor TLockerBuffer.Create(aLockerState    : TLockerState;
                                 aStorageBinding : TAbstractStorageBinding;
                                 aUIBinding      : TAbstractUIBinding = NIL);
//===============================================================
// the UI Binding is optional -- without it, we can operate on just the data
begin
  FLockerState    := aLockerState;
  FFromStorage    := TStringList.Create;
  FFromWidgets    := TStringList.Create;
  FStorageBinding := aStorageBinding;
  FUIBinding      := aUIBinding;
end;

//===============================================================
function TLockerBuffer.ChangedKeys : TStringList;
//===============================================================
// This compares the UI with original data and returns a new stringlist
// with only the changed items
var
  i          : integer;
  key        : string;
  storageVal : string;
  widgetVal  : string;
begin
  Result := TStringList.Create;
  for i := 0 to FFromStorage.Count-1 do
  begin
    key        := FFromStorage.Names[i];
    storageVal := FFromStorage.ValueFromIndex[i];
    widgetVal  := FFromWidgets.Values[key];
    if (widgetVal <> storageVal) then
      Result.Values[key] := widgetVal;
  end;
end;

//===============================================================
function TLockerBuffer.IsDirty : Boolean;
//===============================================================
// call this AFTER calling ChangedKeys
begin
  Result := ChangedKeys.Count > 0;
end;

//===============================================================
function TLockerBuffer.FromStorage : string;
//===============================================================
begin
  Result := await( string, FStorageBinding.LoadBufferFromStorage( FLockerState.LockerID, FFromStorage ) );
end;

//===============================================================
procedure TLockerBuffer.ToWidgets;
//===============================================================
begin
  FUIBinding.LoadWidgetsFromBuffer( FFromStorage );
end;

//===============================================================
procedure TLockerBuffer.FromWidgets;
//===============================================================
begin
  FUIBinding.SendWidgetsToBuffer(FFromWidgets);
end;

//===============================================================
function TLockerBuffer.ToStorage : string;
//===============================================================
begin
  Result := '';
  if IsDirty then
    Result := await(string, FStorageBinding.SendBufferToStorage(FLockerState.LockerID, FFromWidgets));
end;

initialization
  if not Assigned(LockerFieldNames) then
    LockerFieldNames := TStringList.Create;

end.
